var map = {
	"./aplikacja_bankowa.png": "7a40",
	"./bank.png": "73b0",
	"./bankier.png": "4c86",
	"./bankomat.png": "d0ec",
	"./budzet.png": "a922",
	"./gotowka.png": "3f52",
	"./hologram.png": "1c54",
	"./inwestycja.png": "5415",
	"./kantor.png": "41fa",
	"./karta_kredytowa.png": "10f5",
	"./karta_platnicza.png": "e051",
	"./kieszonkowe.png": "83dc",
	"./konto_bankowe.png": "bcb5",
	"./limit.png": "04a4",
	"./limit_10-13.png": "5081",
	"./limit_7- 9.png": "4996",
	"./mennica.png": "e96a",
	"./numer_konta.png": "dcfc",
	"./numer_pin.png": "8ebb",
	"./oszczednosci.png": "ee41",
	"./pieniadz.png": "5e2e",
	"./platnosci_zblizeniowe.png": "327f",
	"./pozyczka.png": "cf1c",
	"./premia.png": "c920",
	"./przelew_internetowy.png": "a225",
	"./przelew_na_telefon.png": "1a5a",
	"./saldo.png": "94d6",
	"./terminal_platniczy.png": "a576",
	"./transakcja.png": "9f7e",
	"./waluta.png": "3764",
	"./wyciag_z_konta.png": "54bf",
	"./wytwornia_papierow_wartosciowych.png": "5b39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cc1";